<template lang="pug">
  .module__main
    .module-content__container
      .add-user__btn
        el-button(type="primary" @click="activateAddRequisite()") Добавить
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="blackListRequisites.list"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="value" label="Реквизит" width="200")
            el-table-column(prop="note" label="Примечание" width="200")
            el-table-column(prop="created" label="Добавлен" width="200")
            el-table-column(prop="added_by" label="Инициатор" width="200")
            el-table-column(label="Действия")
              template(slot-scope="scope")
                el-button(size="mini"  type="danger" @click="startDeleteRequisite(scope.row.value)").action__btn Удалить
          el-dialog(
            :visible.sync="isRequisiteAddingActive"
            :before-close="resetRequisiteAdding"
            title="Добавление реквизита"
            width="30%"
          )
            .h3 Введите данные
            .exchange-finish__container
              .exchange-finish__input
                el-input(v-model="addingRequisite.value" placeholder="Реквизит")
              .exchange-finish__input
                el-input(v-model="addingRequisite.note" placeholder="Примечание")
              .exchange-finish__buttons
                el-button(type="success" @click="startAddRequisite()") Добавить
                el-button(type="danger" @click="resetRequisiteAdding()") Отменить
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='blackListRequisites.pagination.count',
            :page-size="per_page",
            :current-page='blackListRequisites.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadBlackList'
          )
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import {
  ADD_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_REQUISITE,
  LOAD_BLACK_LIST_REQUISITES,
} from '@/store/const/exchange';
import instruments from '@/mixins/instruments';

export default {
  name: 'BlackList',
  mixins: [instruments],
  data() {
    return {
      page: 1,
      per_page: 50,
      isRequisiteAddingActive: false,
      addingRequisite: {
        value: '',
        note: '',
      },
    };
  },
  mounted() {
    this.loadBlackList();
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('exchange', {
      blackListRequisites: 'blackListRequisites',
    }),
    isLoading() {
      return this.isCategoryChanged && this.loading(LOAD_BLACK_LIST_REQUISITES) === 'loading';
    },
    hasPagination() {
      let count = this.blackListRequisites.pagination.count / this.blackListRequisites.pagination.per_page;
      return this.blackListRequisites.pagination.count && count > 1;
    },
  },
  methods: {
    ...mapActions('exchange', {
      loadList: LOAD_BLACK_LIST_REQUISITES,
      addRequisite: ADD_BLACK_LIST_REQUISITE,
      deleteRequisite: DELETE_BLACK_LIST_REQUISITE,
    }),
    async loadBlackList(page = 1) {
      await this.loadList({
        params: {
          page,
          per_page: this.per_page,
        },
      });
      this.page = page;
    },
    async activateAddRequisite() {
      this.isRequisiteAddingActive = true;
    },
    async startAddRequisite() {
      this.$confirm(
        `Вы уверены, что хотите добавить реквизит ${this.addingRequisite.value} в черный список?`,
        'Подтверждение',
      )
        .then(async () => {
          const request = await this.addRequisite(this.addingRequisite);
          await this.notifyRequestResult({
            request,
            successMessage: 'Реквизит успешно добавлен',
            methodOnSuccess: async () => {
              this.resetRequisiteAdding();
              await this.loadBlackList(this.page);
            },
          });
        })
        .catch(() => {
          this.$message.info('Добавление отменено');
        });
    },
    async startDeleteRequisite(requisite) {
      this.$confirm(`Вы уверены, что хотите удалить реквизит ${requisite} из черного списка?`, 'Подтверждение')
        .then(async () => {
          const request = await this.deleteRequisite(requisite);
          await this.notifyRequestResult({
            request,
            successMessage: 'Реквизит успешно удален',
            methodOnSuccess: async () => { await this.loadBlackList(this.page); },
          });
        })
        .catch(() => {
          this.$message.info('Удаление отменено');
        });
    },
    resetRequisiteAdding() {
      this.addingRequisite.value = '';
      this.addingRequisite.note = '';
      this.isRequisiteAddingActive = false;
    },
  },
};
</script>
<style>
.add-user__btn {
  margin-bottom: 10px;
}
</style>
